export enum OtdrGeometryStyleEnum {
  brokenDownPoint = 'OtdrBrokenDownPoint',
  lastPoint = 'OtdrLastPoint',
  successLinePath = 'OtdrSuccessLine',
  failureLinePath = 'OtdrFailureLine'
}
